import { Component, Input } from '@angular/core';

@Component({
  selector: 'frontend-triple-dots',
  templateUrl: './frontend-triple-dots.component.html',
  styleUrls: ['frontend-triple-dots.component.scss'],
  standalone: false,
})
export class FrontendTripleDotsComponent {
  @Input() width = '100px';
}
